module.exports = __webpack_public_path__ + "img/beats.22d33fd8.png";